module.exports = __webpack_public_path__ + "img/popupAd-day7.e47d4a70.png";